import { defineMessages } from 'react-intl';

export const reorderFavoritesMessages = defineMessages({
  failedToToggleFavoriteStateMessage: {
    defaultMessage: 'Something went wrong, please try again later.',
    description: 'Reorder screen | Favorites tab | Failed to toggle favorite state message',
  },
});
